

import "./styles.css";
import React, { useState } from "react";
import ReactDOM from "react-dom";
// import ReactTooltip from "react-tooltip";

import MapChart from "./MapChart";
import Map from "./Map";

function IdentifyMaps() {
    const [content, setContent] = useState("");

    return (
        <div>
            <Map setTooltipContent={setContent} />
            {/* <ReactTooltip>{content}</ReactTooltip> */}
        </div>
    );
}

export default IdentifyMaps


